export const fontFamily = '"Rubik", sans-serif';

// SmartWater (opendatasoft) page analysing kapta data, same for every environment
export const smartWaterKaptaUrl = 'https://birdz.opendatasoft.com/pages/kapta_data/';
